import axios from 'axios';

// Set default base URL for your backend API
axios.defaults.baseURL = 'http://localhost:4000'; // Your backend API address
axios.defaults.withCredentials = true; // Allow sending cookies (if required)

let callRefreshOnce = false;

// Add response interceptor to handle token expiration (401 Unauthorized)
axios.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    // Check if the error status is 401 (Unauthorized)
    if (error.response.status === 401 && !callRefreshOnce) {
      callRefreshOnce = true;

      try {
        // Attempt to refresh the token using the /refresh route
        const response = await axios.post('/refresh', {}); // POST to /refresh endpoint
        if (response.status === 200) {
          // Retry the original request with the new token
          return axios(error.config); // Retry the failed request with updated credentials
        }
      } catch (refreshError) {
        // If the refresh token failed, redirect to login page or log out
        console.error('Refresh token expired or invalid');
        window.location.href = '/signin'; // Redirect to login page
      }
    }
    // Reset flag and return the original error if refreshing fails
    callRefreshOnce = false;
    return Promise.reject(error); // Reject with the original error
  }
);

// Export axios instance if needed in other parts of the app
export default axios;
